<template>
  <div style="text-align:center;" class="table11">
    <table border="1" style="border-bottom:0">
      <!-- 第1行(1表) -->
      <tr style="height:100px">
        <td width="25%" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="50%" class="titleSpan tableTitle">顾 客 满 意 度 调 查 表</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <!-- 第2行(2表) -->
      <tr style="height:120px">
        <td width="50%" class="titleSpan">
          <div class="row1Content" style="min-height:120px;">
            <div class="pcontent">
              致：
              <span class="underline">{{'xxxxxxxx'}}</span>
            </div>
            <div class="pcontent">
              河南邦泰合力管理咨询有限公司承接贵公司（项目名称）：
              <span class="underline">{{'xxxxxxxx'}}</span>开展工作以来，承蒙您的关怀和厚爱。为了更好地满足您对我们服务的要求与期望，请您对服务质量进行评价。
            </div>
          </div>
        </td>
      </tr>
      <!-- 第3行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">评价机构是否按照评价项目合同规定安排评价人员进驻现场？</div>
            <div class="table11Item">
              <div class="dabox">答:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- 第4行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">评价机构是否按照评价项目合同规定的时间完成评价报告？</div>
            <div class="table11Item">
              <div class="dabox">答:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- 第5行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">评价机构是否向第三方泄露了本企业的技术及商业秘密？</div>
            <div class="table11Item">
              <div class="dabox">答:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- 第6行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">评价结论是否客观、公正？</div>
            <div class="table11Item">
              <div class="dabox">答:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- 第7行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">评价机构的人员的专业技术水平如何？</div>
            <div class="table11Item">
              <div class="dabox">答:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>很高</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>较高</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>一般</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==3"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>较低</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==4"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>很低</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==5"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- 第8行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">评价机构的人员工作作风和敬业精神如何？</div>
            <div class="table11Item">
              <div class="dabox">答:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>很高</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>较高</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>一般</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==3"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>较低</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==4"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>很低</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==5"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- 第9行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">评价项目完成后，对企业的安全管理、安全技术改善是否有促进作用？</div>
            <div class="table11Item">
              <div class="dabox">答:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- 第10行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">对评价机构服务质量的总体评价如何？</div>
            <div class="table11Item">
              <div class="dabox">答:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>满意</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>不满意</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- 第11行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="row2ContentTitle">对评价机构评价人员的意见或建议：</div>
            <div class="daText">{{`答:${'123'}`}}</div>
          </div>
        </td>
      </tr>
      <!-- 第10行 -->
      <tr style="height:80px">
        <td width="50%" class="titleSpan">
          <div class="row2Content" style="min-height:80px;">
            <div class="table11Item">
              <div class="dabox">综合结论:</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>1、满意</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>2、基本满意</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>3、不满意</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==3"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <!-- 第十三行(4表) -->
      <tr style="height:100px">
        <td colspan="4" style="text-align:left;">
          <div style="min-height:100px;box-sizing:border-box;padding:10px;" class="wirteTableRow">
            <div class="pic">
              <div>企业代表（签字或盖章）:</div>
              <img src="../../assets/image/icon_MP4@2x.png" alt />
            </div>
            <div>年月日</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>